module.exports = __webpack_public_path__ + "static/builder-three@2x-8d0367c3fd8d3d63ae22c8e5665b5949.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/android-app-builder/builder-three@2x.png
// module id = 2536
// module chunks = 168707334958949